import { Component, Input } from '@angular/core';
import { ErrorTrackingService } from '../../services/error-tracking.service';

@Component({
  selector: 'app-alerta-error',
  templateUrl: './alerta-error.component.html',
  styleUrls: ['./alerta-error.component.scss']
})
export class AlertaErrorComponent {
  @Input() errores?: any;
  @Input() mensaje_unico: string = "";
  @Input() tipo: string = "error";
  cantidadErrores: number = 0;
  constructor(public errorTrackingService: ErrorTrackingService) { }

}
